
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '@/hooks/useTranslation';
import { Button } from '@/components/ui/button';
import { Users } from 'lucide-react';
import LogoutButton from '@/components/LogoutButton';

interface MobileMenuProps {
  isLoggedIn: boolean;
  handleLogin: () => void;
  handleDashboard: () => void;
  isSuper: boolean;
  renderRoleBadge: () => React.ReactNode;
  userRole?: { plan_tier?: string };
  direction: 'rtl' | 'ltr';
}

const MobileMenu: React.FC<MobileMenuProps> = ({
  isLoggedIn,
  handleLogin,
  handleDashboard,
  isSuper,
  renderRoleBadge,
  userRole,
  direction
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="md:hidden pt-4 pb-3 border-t mt-4">
      <a href="#features" className="block py-2 text-synagogue-blue hover:text-synagogue-gold">
        {t('navProduct')}
      </a>
      <a href="#pricing" className="block py-2 text-synagogue-blue hover:text-synagogue-gold">
        {t('navPricing')}
      </a>
      <a href="#demo" className="block py-2 text-synagogue-blue hover:text-synagogue-gold">
        {t('navDemo')}
      </a>
      <div className="mt-4 flex flex-col space-y-2">
        {isLoggedIn ? (
          <>
            <div className="flex items-center py-2">
              {renderRoleBadge()}
              <span className="mr-2 text-sm">
                {userRole?.plan_tier === 'premium' ? 'פרימיום' : userRole?.plan_tier === 'professional' ? 'מקצועי' : 'בסיסי'}
              </span>
            </div>
            
            <Button 
              variant="ghost" 
              size="sm" 
              className="justify-start"
              onClick={handleDashboard}
            >
              {t('navDashboard')}
            </Button>
            
            {isSuper && (
              <Button 
                variant="ghost" 
                size="sm" 
                className="justify-start"
                onClick={() => navigate('/admin/users')}
              >
                <Users className="ml-2 h-4 w-4" />
                ניהול משתמשים
              </Button>
            )}
            
            <LogoutButton />
          </>
        ) : (
          <>
            <Button 
              variant="ghost" 
              size="sm" 
              className="justify-start"
              onClick={handleLogin}
            >
              {t('navLogin')}
            </Button>
            <Button 
              className="bg-synagogue-gold hover:bg-synagogue-blue text-white"
              onClick={handleLogin}
            >
              {t('navSignup')}
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default MobileMenu;
